import {
  Component,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { NavigationEnd, Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';
import { isIosTouchScrollDevice } from 'src/app/utils/ios-touch-scroll';
import { isAxAppWebView } from 'src/app/utils/is-ax-app-webview';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-meal-description-page',
  templateUrl: './meal-description-page.component.html',
  styleUrls: ['./meal-description-page.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MealDescriptionPageComponent implements OnInit, OnDestroy, AfterViewInit {
  imagepath = '';
  validsession: boolean | undefined;
  userData?: UserData;
  shpId: number | undefined;

  private keyboardViewportAbort?: AbortController;
  private routerSub?: Subscription;
  private reapplyTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private appConfigService: AppConfigService,
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private employeeLoginService: EmployeeloginService) {
    this.applyMealPageScrollMode();
  }

  ngOnInit(): void {
    this.imagepath = this.appConfigService.imagepath;
    this.userData = this.employeeLoginService.GetEmployeeAndUserData().userData;
    this.shpId = this.userData.shipid!;

    this.applyMealPageScrollMode();
    this.reapplyTimeout = setTimeout(() => this.applyMealPageScrollMode(), 550);

    this.routerSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => this.applyMealPageScrollMode(), 0);
      });
  }

  ngAfterViewInit(): void {
    this.applyMealPageScrollMode();
    if (isIosTouchScrollDevice() || isAxAppWebView()) {
      this.attachKeyboardViewportHandling();
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.reapplyTimeout);
    this.routerSub?.unsubscribe();
    this.detachKeyboardViewportHandling();
    document.documentElement.classList.remove('meal-page-active', 'keyboard-open');
    document.body.classList.remove('meal-page-active', 'keyboard-open');
    document.documentElement.style.removeProperty('--keyboard-offset');
    document.body.style.removeProperty('top');
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  private applyMealPageScrollMode(): void {
    document.documentElement.classList.add('meal-page-active');
    document.body.classList.add('meal-page-active', 'ios-touch-scroll');
  }

  private attachKeyboardViewportHandling(): void {
    const viewport = window.visualViewport;
    if (!viewport || this.keyboardViewportAbort) {
      return;
    }

    this.keyboardViewportAbort = new AbortController();
    const { signal } = this.keyboardViewportAbort;

    const update = () => {
      const offset = Math.max(
        0,
        window.innerHeight - viewport.height - viewport.offsetTop
      );
      const keyboardOpen = offset > 50;

      document.documentElement.style.setProperty(
        '--keyboard-offset',
        `${offset}px`
      );
      document.documentElement.classList.toggle('keyboard-open', keyboardOpen);
      document.body.classList.toggle('keyboard-open', keyboardOpen);
    };

    viewport.addEventListener('resize', update, { signal });
    update();
  }

  private detachKeyboardViewportHandling(): void {
    this.keyboardViewportAbort?.abort();
    this.keyboardViewportAbort = undefined;
  }
}
